<template lang="html">
  <div class="modal-wrapper register">
    <div class="modal-close">
      <div @click="openModal('chooseRegistrationModal')" class="back-wrapper">
        <img src="@/assets/icons/backArrow.png" alt="back arrow image" />
        <span>{{ $t("main.goBack") }}</span>
      </div>
      <img
        @click="closeModal()"
        src="@/assets/icons/close.png"
        alt="close-modal-img"
      />
    </div>
    <div class="modal-title">
      {{ $t("main.registrationBusiness") }}
    </div>
    <div class="modal-text-wrapper">
      <span v-html="$t('modal.standardRegistrationText')"></span>
      <router-link
        target="_blank"
        :to="{ name: 'Rules', params: { lang: $i18n.locale } }"
        ><span>{{ $t("nav.rules") }}</span></router-link
      >.
    </div>
    <div class="modal-checkbox">
      <label class="checkbox-wrapper">
        <input
          autocomplete="off"
          @change="rulesError = false"
          v-model="rules"
          type="checkbox"
        />
        <span class="checkmark"></span>
      </label>
      <router-link
        target="_blank"
        :to="{ name: 'Rules', params: { lang: $i18n.locale } }"
      >
        <div class="modal-checkbox-text">
          {{ $t("modal.acceptRules") }}
        </div>
      </router-link>
    </div>
    <div class="inputs-wrapper">
      <div class="input-wrapper">
        <input
          autocomplete="off"
          @input="(errors.usr_email = false), (emailTaken = false)"
          v-model="user.usr_email"
          type="text"
          :placeholder="$t('main.email') + '*'"
          class="regular-input"
          onkeydown="this.value = this.value.replace(' ', '');"
          oninput="this.value = this.value.replace(' ', '');"
        />
        <div class="label-wrapper">
          <span
            v-if="user.usr_email !== null && user.usr_email !== ''"
            class="label"
            >{{ $t("main.email") + "*" }}</span
          >
          <span v-if="errors.usr_email" class="error">{{
            $t("errors.registration.email")
          }}</span>
          <span v-if="emailTaken" class="error">{{
            $t("errors.registration.emailTaken")
          }}</span>
        </div>
      </div>

      <div class="input-wrapper">
        <input
          @input="errors.usr_name = false"
          v-model="user.usr_name"
          type="text"
          :placeholder="$t('main.firm') + '*'"
          class="regular-input"
        />
        <div class="label-wrapper">
          <span
            v-if="user.usr_name !== null && user.usr_name !== ''"
            class="label"
            >{{ $t("main.firm") + "*" }}</span
          >
          <span v-if="errors.usr_name" class="error">{{
            $t("errors.registration.orgName")
          }}</span>
        </div>
      </div>

      <div class="input-wrapper">
        <input
          @input="errors.usr_org_full_name = false"
          v-model="user.usr_org_full_name"
          type="text"
          :placeholder="$t('main.usr_org_full_name') + '*'"
          class="regular-input"
        />
        <div class="label-wrapper">
          <span
            v-if="
              user.usr_org_full_name !== null && user.usr_org_full_name !== ''
            "
            class="label"
            >{{ $t("main.usr_org_full_name") + "*" }}</span
          >
          <span v-if="errors.usr_org_full_name" class="error">{{
            $t("errors.registration.usr_org_full_name")
          }}</span>
        </div>
      </div>

      <div class="input-wrapper">
        <input
          onkeydown="this.value = this.value.replace(/(?!^\+)[^0-9 ]/g, '').replace(/[ ]{2,}/g, '');"
          oninput="this.value = this.value.replace(/(?!^\+)[^0-9 ]/g, '').replace(/[ ]{2,}/g, '');"
          @input="errors.usr_phone_number = false"
          v-model="user.usr_phone_number"
          type="text"
          :placeholder="$t('main.phone') + '*'"
          class="regular-input"
        />
        <div class="label-wrapper">
          <span
            v-if="
              user.usr_phone_number !== null && user.usr_phone_number !== ''
            "
            class="label"
            >{{ $t("main.phoneInfo") }}</span
          >
          <span v-if="errors.usr_phone_number" class="error">{{
            $t("errors.registration.phone")
          }}</span>
        </div>
      </div>

      <div
        class="input-wrapper"
        v-if="user.usr_phone_number !== null && user.usr_phone_number !== ''"
      >
        <input
          onkeydown="this.value = this.value.replace(/(?!^\+)[^0-9 ]/g, '').replace(/[ ]{2,}/g, '');"
          oninput="this.value = this.value.replace(/(?!^\+)[^0-9 ]/g, '').replace(/[ ]{2,}/g, '');"
          @input="errors.usr_phone_number1 = false"
          v-model="user.usr_phone_number1"
          type="text"
          :placeholder="$t('main.phone')"
          class="regular-input"
        />
        <div class="label-wrapper">
          <span
            v-if="
              user.usr_phone_number1 !== null && user.usr_phone_number1 !== ''
            "
            class="label"
            >{{ $t("main.phoneInfo") }}</span
          >
          <span v-if="errors.usr_phone_number1" class="error">{{
            $t("errors.registration.phone")
          }}</span>
        </div>
      </div>

      <div
        class="input-wrapper"
        v-if="user.usr_phone_number1 !== null && user.usr_phone_number1 !== ''"
      >
        <input
          onkeydown="this.value = this.value.replace(/(?!^\+)[^0-9 ]/g, '').replace(/[ ]{2,}/g, '');"
          oninput="this.value = this.value.replace(/(?!^\+)[^0-9 ]/g, '').replace(/[ ]{2,}/g, '');"
          @input="errors.usr_phone_number2 = false"
          v-model="user.usr_phone_number2"
          type="text"
          :placeholder="$t('main.phone')"
          class="regular-input"
        />
        <div class="label-wrapper">
          <span
            v-if="
              user.usr_phone_number2 !== null && user.usr_phone_number2 !== ''
            "
            class="label"
            >{{ $t("main.phoneInfo") }}</span
          >
          <span v-if="errors.usr_phone_number2" class="error">{{
            $t("errors.registration.phone")
          }}</span>
        </div>
      </div>

      <div
        class="input-wrapper"
        v-if="user.usr_phone_number2 !== null && user.usr_phone_number2 !== ''"
      >
        <input
          onkeydown="this.value = this.value.replace(/(?!^\+)[^0-9 ]/g, '').replace(/[ ]{2,}/g, '');"
          oninput="this.value = this.value.replace(/(?!^\+)[^0-9 ]/g, '').replace(/[ ]{2,}/g, '');"
          @input="errors.usr_phone_number3 = false"
          v-model="user.usr_phone_number3"
          type="text"
          :placeholder="$t('main.phone')"
          class="regular-input"
        />
        <div class="label-wrapper">
          <span
            v-if="
              user.usr_phone_number3 !== null && user.usr_phone_number3 !== ''
            "
            class="label"
            >{{ $t("main.phoneInfo") }}</span
          >
          <span v-if="errors.usr_phone_number3" class="error">{{
            $t("errors.registration.phone")
          }}</span>
        </div>
      </div>

      <!-- <input autocomplete="off" v-model="user.usr_email" type="text" :placeholder="$t('main.postalCode')" class="regular-input"> -->
      <div class="input-wrapper">
        <input
          autocomplete="off"
          @input="(errors.org_pib = false), (pibTaken = false)"
          v-model="user.org_pib"
          type="text"
          :placeholder="$t('main.pib') + '*'"
          class="regular-input"
        />
        <div class="label-wrapper">
          <span
            v-if="user.org_pib !== null && user.org_pib !== ''"
            class="label"
            >{{ $t("main.pib") + "*" }}</span
          >
          <span v-if="errors.org_pib" class="error">{{
            $t("errors.registration.pib")
          }}</span>
          <span v-if="pibTaken" class="error">{{
            $t("errors.registration.pibTaken")
          }}</span>
        </div>
      </div>

      <div class="input-wrapper">
        <input
          autocomplete="off"
          @input="(errors.org_id = false), (idTaken = false)"
          v-model="user.org_id"
          type="text"
          :placeholder="$t('main.mbf') + '*'"
          class="regular-input"
        />
        <div class="label-wrapper">
          <span
            v-if="user.org_id !== null && user.org_id !== ''"
            class="label"
            >{{ $t("main.mbf") + "*" }}</span
          >
          <span v-if="errors.org_id" class="error">{{
            $t("errors.registration.mb")
          }}</span>
          <span v-if="idTaken" class="error">{{
            $t("errors.registration.idTaken")
          }}</span>
        </div>
      </div>

      <div class="input-wrapper">
        <input
          autocomplete="off"
          @input="errors.usr_org_registration_number = false"
          v-model="user.usr_org_registration_number"
          type="text"
          :placeholder="$t('main.usr_org_registration_number') + '*'"
          class="regular-input"
        />
        <div class="label-wrapper">
          <span
            v-if="
              user.usr_org_registration_number !== null &&
                user.usr_org_registration_number !== ''
            "
            class="label"
            >{{ $t("main.usr_org_registration_number") + "*" }}</span
          >
          <span v-if="errors.usr_org_registration_number" class="error">{{
            $t("errors.registration.usr_org_registration_number")
          }}</span>
        </div>
      </div>

      <div class="input-wrapper">
        <input
          autocomplete="off"
          @input="errors.usr_org_bank = false"
          v-model="user.usr_org_bank"
          type="text"
          :placeholder="$t('main.usr_org_bank') + '*'"
          class="regular-input"
        />
        <div class="label-wrapper">
          <span
            v-if="user.usr_org_bank !== null && user.usr_org_bank !== ''"
            class="label"
            >{{ $t("main.usr_org_bank") + "*" }}</span
          >
          <span v-if="errors.usr_org_bank" class="error">{{
            $t("errors.registration.usr_org_bank")
          }}</span>
        </div>
      </div>

      <div class="input-wrapper">
        <div class="info">
          <div class="info-key">
            <span>{{ $t("main.usr_business_register") + "*" }}</span>
          </div>
          <questionmark :id="57" :toast="true" />
          <div class="info-value">
            <span v-if="user.usr_business_register">{{
              user.usr_business_register.name
            }}</span>
            <label for="usr_business_register" class="btn">
              {{ $t("details.details.choose") }}
            </label>
            <input
              autocomplete="off"
              style="display: none;"
              id="usr_business_register"
              @change="
                (errors.usr_business_register = false),
                  (user.usr_business_register = $event.target.files[0])
              "
              type="file"
              :placeholder="$t('main.usr_business_register')"
              class="regular-input"
            />
          </div>
        </div>
        <div class="label-wrapper">
          <span v-if="errors.usr_business_register" class="error">{{
            $t("errors.registration.usr_business_register")
          }}</span>
        </div>
      </div>

      <div class="input-wrapper">
        <div class="info">
          <div class="info-key">
            <span>{{ $t("main.file") }}</span>
          </div>
          <questionmark :id="58" :toast="true" />
          <div class="info-value">
            <span v-if="user.usr_tax_info">{{ user.usr_tax_info.name }}</span>
            <label for="usr_tax_info" class="btn">
              {{ $t("details.details.choose") }}
            </label>
            <input
              autocomplete="off"
              style="display: none;"
              id="usr_tax_info"
              @change="
                (errors.usr_tax_info = false),
                  (user.usr_tax_info = $event.target.files[0])
              "
              type="file"
              :placeholder="$t('main.usr_tax_info')"
              class="regular-input"
            />
          </div>
        </div>
        <div class="label-wrapper">
          <span v-if="errors.usr_tax_info" class="error">{{
            $t("errors.registration.usr_tax_info")
          }}</span>
        </div>
      </div>
      <!-- ------------- ----     ----->

      <div class="input-wrapper">
        <input
          v-model="user.org_services"
          type="text"
          :placeholder="$t('main.firmField')"
          class="regular-input"
          maxlength="255"
        />
        <div class="label-wrapper">
          <span
            v-if="user.org_services !== null && user.org_services !== ''"
            class="label"
            >{{ $t("main.firmField") }}</span
          >
        </div>
      </div>

      <!-- <div class="input-wrapper">
        <dropdown class="dropdown"
          :defaultText="$t('main.firmField') + '*'"
          :selected="user.org_services"
          :list="organisationServices"
          @changeOption="user.org_services = $event, errors.org_services = false"
        />
        <div class="label-wrapper">
          <span v-if="user.org_services !== null && user.org_services !== ''" class="label">{{$t('main.firmField') + '*'}}</span>
          <span v-if="errors.org_services" class="error">{{$t('errors.registration.field')}}</span>
        </div>
      </div> -->
      <!-- -------------      -->
      <!-- <div class="input-wrapper">
        <dropdown class="dropdown"
          :defaultText="$t('main.firmType') + '*'"
          :selected="user.org_type"
          :list="organisationType"
          @changeOption="user.org_type = $event, errors.org_type = false"
        />
        <div class="label-wrapper">
          <span v-if="user.org_type !== null && user.org_type !== ''" class="label">{{$t('main.firmType') + '*'}}</span>
          <span v-if="errors.org_type" class="error">{{$t('errors.registration.orgType')}}</span>
        </div>
      </div> -->
      <div class="input-wrapper">
        <dropdown
          class="dropdown"
          :defaultText="$t('main.firmType') + '*'"
          :selected="user.org_type"
          :list="organisationType"
          @changeOption="(user.org_type = $event), (errors.org_type = false)"
        />
        <div class="label-wrapper">
          <span
            v-if="user.org_type !== null && user.org_type !== ''"
            class="label"
            >{{ $t("main.firmType") + "*" }}</span
          >
          <span v-if="errors.org_type" class="error">{{
            $t("errors.registration.orgType")
          }}</span>
        </div>
      </div>

      <!-- ----------------- -->

      <div class="input-wrapper">
        <input
          @input="errors.usr_org_contact_person = false"
          v-model="user.usr_org_contact_person"
          type="text"
          :placeholder="$t('main.usr_org_contact_person') + '*'"
          class="regular-input"
        />
        <div class="label-wrapper">
          <span
            v-if="
              user.usr_org_contact_person !== null &&
                user.usr_org_contact_person !== ''
            "
            class="label"
            >{{ $t("main.usr_org_contact_person") + "*" }}</span
          >
          <span v-if="errors.usr_org_contact_person" class="error">{{
            $t("errors.registration.usr_org_contact_person")
          }}</span>
        </div>
      </div>

      <div class="input-wrapper">
        <input
          autocomplete="off"
          @input="errors.org_contact = false"
          v-model="user.org_contact"
          type="text"
          :placeholder="$t('main.contactPerson') + '*'"
          class="regular-input"
        />
        <div class="label-wrapper">
          <span
            v-if="user.org_contact !== null && user.org_contact !== ''"
            class="label"
            >{{ $t("main.contactPerson") + "*" }}</span
          >
          <span v-if="errors.org_contact" class="error">{{
            $t("errors.registration.email")
          }}</span>
        </div>
      </div>

      <div class="input-wrapper">
        <dropdown
          :defaultText="$t('main.country') + '*'"
          :selected="user.usr_country"
          :list="countries"
          @changeOption="
            (user.usr_country = $event), (errors.usr_country = false)
          "
        />
        <!-- <input autocomplete="off" @input="errors.usr_country = false" v-model="user.usr_country" type="text" :placeholder="$t('main.country')" class="regular-input"> -->
        <div class="label-wrapper">
          <span
            v-if="user.usr_country !== null && user.usr_country !== ''"
            class="label"
            >{{ $t("main.country") + "*" }}</span
          >
          <span v-if="errors.usr_country" class="error">{{
            $t("errors.registration.country")
          }}</span>
        </div>
      </div>

      <div class="input-wrapper">
        <input
          autocomplete="off"
          @input="errors.usr_region = false"
          v-model="user.usr_region"
          type="text"
          :placeholder="$t('main.location') + '*'"
          class="regular-input"
        />
        <div class="label-wrapper">
          <span
            v-if="user.usr_region !== null && user.usr_region !== ''"
            class="label"
            >{{ $t("main.location") + "*" }}</span
          >
          <span v-if="errors.usr_region" class="error">{{
            $t("errors.registration.location")
          }}</span>
        </div>
      </div>

      <div class="input-wrapper">
        <input
          autocomplete="off"
          @input="errors.usr_address = false"
          v-model="user.usr_address"
          type="text"
          :placeholder="$t('main.address') + '*'"
          class="regular-input"
        />
        <div class="label-wrapper">
          <span
            v-if="user.usr_address !== null && user.usr_address !== ''"
            class="label"
            >{{ $t("main.address") + "*" }}</span
          >
          <span v-if="errors.usr_address" class="error">{{
            $t("errors.registration.address")
          }}</span>
        </div>
      </div>

      <div class="input-wrapper">
        <input
          @input="errors.usr_postal_code = false"
          v-model="user.usr_postal_code"
          type="text"
          :placeholder="$t('main.usr_postal_code') + '*'"
          class="regular-input"
          maxlength="45"
        />
        <div class="label-wrapper">
          <span
            v-if="user.usr_postal_code !== null && user.usr_postal_code !== ''"
            class="label"
            >{{ $t("main.usr_postal_code") + "*" }}</span
          >
          <span v-if="errors.usr_postal_code" class="error">{{
            $t("errors.registration.usr_postal_code")
          }}</span>
        </div>
      </div>

      <div class="input-wrapper">
        <input
          autocomplete="off"
          @keyup="errors.usr_pr_text = false"
          v-model="user.usr_pr_text"
          type="text"
          :placeholder="$t('main.pr')"
          class="regular-input"
        />
        <div class="label-wrapper">
          <span
            v-if="user.usr_pr_text !== null && user.usr_pr_text !== ''"
            class="label"
            >{{ $t("main.pr") }}</span
          >
          <span v-if="errors.usr_pr_text" class="error">{{
            $t("errors.registration.prError")
          }}</span>
        </div>
      </div>

      <div class="input-wrapper">
        <div class="info">
          <label class="info-key" for="notification">{{
            $t("profile.sugestions.notifications") + "*"
          }}</label
          ><br />
          <input
            autocomplete="off"
            class="info-value"
            type="checkbox"
            id="notification"
            v-model="user.usr_notifications"
          />
        </div>
      </div>

      <div class="input-wrapper">
        <div class="info">
          <label class="info-key" for="newsletter">{{
            $t("profile.sugestions.newsletter") + "*"
          }}</label>
          <input
            autocomplete="off"
            class="info-value"
            type="checkbox"
            id="newsletter"
            v-model="user.usr_newsletter"
          />
        </div>
      </div>

      <div class="input-wrapper">
        <div class="info">
          <label class="info-key" for="privacy">{{
            $t("profile.sugestions.privacyS") + "*"
          }}</label
          ><br />
          <input
            autocomplete="off"
            class="info-value"
            type="checkbox"
            id="privacy"
            v-model="user.usr_private"
          />
        </div>
      </div>

      <div
        v-for="(social, index) in socials"
        :key="social.sct_id"
        class="input-wrapper"
      >
        <!-- <div class="info">
          <span class="info-key">{{ social.sct_name }} :</span>
          <span class="info-value">
            <input autocomplete="off" maxlength="255" type="text" @change="setSocial(social.sct_id, $event.target.value)">
          </span>
        </div> -->
        <input
          autocomplete="off"
          @input="setSocial(social.sct_id, $event.target.value)"
          type="text"
          :placeholder="social.sct_name"
          class="regular-input"
        />
        <div class="label-wrapper">
          <span
            v-if="
              user.socials[index] &&
                user.socials[index].link &&
                user.socials[index].link !== null &&
                user.socials[index].link !== ''
            "
            class="label"
            >{{ social.sct_name }}</span
          >
        </div>
      </div>

      <div class="input-wrapper">
        <input
          autocomplete="off"
          @input="(errors.usr_username = false), (usernameTaken = false)"
          v-model="user.usr_username"
          type="text"
          :placeholder="$t('main.username') + '*'"
          class="regular-input"
        />
        <div class="label-wrapper">
          <span
            v-if="user.usr_username !== null && user.usr_username !== ''"
            class="label"
            >{{ $t("main.username") + "*" }}</span
          >
          <span v-if="errors.usr_username" class="error">{{
            $t("errors.registration.username")
          }}</span>
          <span v-if="usernameTaken" class="error">{{
            $t("errors.registration.usernameTaken")
          }}</span>
        </div>
      </div>

      <div class="input-wrapper">
        <input
          autocomplete="off"
          @input="errors.usr_password = false"
          v-model="user.usr_password"
          type="password"
          :placeholder="$t('main.password') + '*'"
          class="regular-input"
        />
        <div class="label-wrapper">
          <span
            v-if="user.usr_password !== null && user.usr_password !== ''"
            class="label"
            >{{ $t("main.password") + "*" }}</span
          >
          <span v-if="errors.usr_password" class="error">{{
            $t("errors.registration.password")
          }}</span>
        </div>
      </div>

      <div class="input-wrapper no-margin">
        <input
          autocomplete="off"
          v-model="confirmPassword"
          type="password"
          :placeholder="$t('main.confirmPassword') + '*'"
          class="regular-input"
        />
        <div class="label-wrapper">
          <span
            v-if="confirmPassword !== null && confirmPassword !== ''"
            class="label"
            >{{ $t("main.confirmPassword") + "*" }}</span
          >
          <span v-if="user.usr_password !== confirmPassword" class="error">{{
            $t("errors.registration.samePasswords")
          }}</span>
        </div>
      </div>

      <div class="input-wrapper">
        <div class="label-wrapper">
          <span class="label">{{ $t("main.inputsRequired") }}</span>
        </div>
      </div>
    </div>
    <TurnStile :resetToken="resetToken" @set-token="setToken" />
    <div class="btn-wrapper">
      <div @click="register" class="btn">
        {{ $t("main.registrationConfirm") }}
      </div>
      <div v-if="rulesError" class="error">
        {{ $t("errors.registration.rules") }}
      </div>
    </div>
    <div v-html="$t('main.recaptchaWarn')" class="recaptcha-warn"></div>
  </div>
</template>

<script>
import Questionmark from "@/components/questionmark.vue";
import eventBus from "@/shared/eventBus.js";
import Dropdown from "@/components/dropdown.vue";
import { api } from "@/api";
import TurnStile from "@/components/TurnStileVue2.vue";

export default {
  name: "registerModal",
  components: {
    Dropdown,
    Questionmark,
    TurnStile
  },
  data() {
    return {
      localToken: "",
      resetToken: false,
      phoneFocus: false,
      user: {
        usr_email: null,
        usr_username: null,
        usr_org_full_name: null,
        usr_password: null,
        usr_phone_number: null,
        usr_phone_number1: null,
        usr_phone_number2: null,
        usr_phone_number3: null,
        usr_address: null,
        usr_postal_code: null,
        usr_region: null,
        usr_country: null,
        org_pib: null,
        usr_business_register: null,
        usr_tax_info: null,
        usr_name: null,
        org_services: null, // postaje string
        business_activiti: null,
        // Type of business organization
        org_type: null,
        org_id: null,
        org_contact: null,
        usr_org_contact_person: null,
        type: "org",
        usr_org_registration_number: null,
        usr_org_bank: null,
        usr_notifications: false,
        usr_newsletter: false,
        usr_private: false,
        socials: [],
        usr_pr_text: null
      },
      errors: {
        usr_email: false,
        usr_username: false,
        usr_org_full_name: false,
        usr_password: false,
        usr_phone_number: false,
        usr_phone_number1: false,
        usr_phone_number2: false,
        usr_phone_number3: false,
        usr_address: false,
        usr_postal_code: false,
        usr_region: false,
        usr_country: false,
        org_pib: false,
        usr_business_register: false,
        usr_tax_info: false,
        usr_name: false,
        org_services: false,
        org_type: false,
        org_id: false,
        org_contact: false,
        usr_org_contact_person: false,
        usr_org_registration_number: false,
        usr_org_bank: false,
        usr_pr_text: false
      },
      usernameTaken: false,
      emailTaken: false,
      pibTaken: false,
      idTaken: false,
      confirmPassword: null,
      rules: false,
      rulesError: false,
      countries: [],
      organisationType: [],
      organisationServices: [],
      socials: []
    };
  },
  mounted() {
    this.getCountries();
    this.getOrganisationType();
    this.getOrganisationServices();
    this.getSocialTypes();
  },
  methods: {
    openModal(modal) {
      eventBus.$emit("openModal", { component: modal });
    },
    closeModal() {
      eventBus.$emit("closeModal");
    },
    async getSocialTypes() {
      await api.getSocialTypes().then(res => {
        this.socials = res.data.data;
      });
    },
    setSocial(id, link) {
      for (var i = 0; i < this.user.socials.length; i++) {
        if (this.user.socials[i].sct_id === id) {
          if (link !== "") {
            this.user.socials[i].link = link;
          } else {
            this.user.socials.splice(i, 1);
          }
          return;
        }
      }
      let obj = {
        sct_id: id,
        link: link
      };
      this.user.socials.push(obj);
    },
    getCountries() {
      api
        .getCountries()
        .then(res => {
          let data = res.data.data;
          for (var i = 0; i < data.length; i++) {
            let obj = {
              label: data[i].cnt_name,
              value: data[i].cnt_id
            };
            this.countries.push(obj);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    getOrganisationType() {
      // Type of business organization not change
      api
        .getOrganisationType()
        .then(res => {
          let data = res.data.data;
          for (let i = 0; i < data.length; i++) {
            let obj = {
              label: data[i].otp_name,
              value: data[i].otp_id
            };
            this.organisationType.push(obj);
            console.log(data[i].otp_name);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    // lista nije potrebna
    getOrganisationServices() {
      api
        .getOrganisationServices()
        .then(res => {
          let data = res.data.data;
          console.log(data);
          for (let i = 0; i < data.length; i++) {
            let obj = {
              label: data[i].osr_name,
              value: data[i].osr_id
            };
            this.organisationServices.push(obj);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    async register() {
      if (this.user.usr_pr_text && this.user.usr_pr_text.length > 1100) {
        this.errors.usr_pr_text = true;
        return;
      }
      if (!this.rules) {
        this.rulesError = true;
        this.$toast.error(this.$t("errors.registration.rules"), {
          duration: 8000
        });
        return;
      }
      // await this.$recaptchaLoaded();
      // const token = await this.$recaptcha("login");
      const params = Object.assign({}, this.user);
      if (params.usr_country) {
        params.usr_country = params.usr_country.value;
      }
      // if (params.org_services) {
      //   params.org_services = this.user.org_services.value
      // }

      // Type of business organization
      if (params.org_type) {
        params.org_type = this.user.org_type.value;
      }

      if (params.socials) {
        params.socials = JSON.stringify(params.socials);
      }
      params.token = this.localToken;
      this.resetToken = !this.resetToken;

      this.fixEmptyStrings(params);
      let formData = new FormData();
      for (var variable in params) {
        if (params.hasOwnProperty(variable)) {
          formData.append(variable, params[variable]);
        }
      }
      eventBus.$emit("showLoader", true);
      api
        .register(formData)
        .then(res => {
          this.$toast.success(this.$t("toast.registerSuccess"), {
            duration: 8000
          });
          this.closeModal();
        })
        .catch(e => {
          this.handleErrors(e.response);
        })
        .finally(() => {
          eventBus.$emit("showLoader", false);
        });
    },
    handleErrors(response) {
      if (response.data.hasOwnProperty("missing")) {
        for (var i = 0; i < response.data.missing.length; i++) {
          this.errors[response.data.missing[i]] = true;
        }
        this.$toast.error(this.$t("errors.registration.missing"), {
          duration: 8000
        });
      }
      if (response.data.hasOwnProperty("invalid")) {
        for (i = 0; i < response.data.invalid.length; i++) {
          this.errors[response.data.invalid[i]] = true;
        }
        this.$toast.error(this.$t("errors.registration.invalid"), {
          duration: 8000
        });
      }
      if (response.data.hasOwnProperty("same")) {
        for (i = 0; i < response.data.same.length; i++) {
          if (response.data.same[i] === "usr_username") {
            this.usernameTaken = true;
            this.$toast.error(this.$t("errors.registration.usernameTaken"), {
              duration: 8000
            });
          } else if (response.data.same[i] === "usr_email") {
            this.emailTaken = true;
            this.$toast.error(this.$t("errors.registration.emailTaken"), {
              duration: 8000
            });
          } else if (response.data.same[i] === "org_pib") {
            this.pibTaken = true;
            this.$toast.error(this.$t("errors.registration.pibTaken"), {
              duration: 8000
            });
          } else if (response.data.same[i] === "org_id") {
            this.idTaken = true;
            this.$toast.error(this.$t("errors.registration.idTaken"), {
              duration: 8000
            });
          }
        }
      }
    },
    fixEmptyStrings(obj) {
      for (var variable in obj) {
        if (obj.hasOwnProperty(variable)) {
          if (
            obj[variable] === "" ||
            obj[variable] === null ||
            obj[variable].length === 0
          ) {
            delete obj[variable];
          }
        }
      }
      return obj;
    },
    setToken(e) {
      this.localToken = e;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/modalStyles.scss";
@import "@/assets/scss/inputStyles.scss";
@import "@/assets/scss/checkboxStyles.scss";
@import "@/assets/scss/scrollbarStyles.scss";
@import "@/assets/scss/btnStyles.scss";
.modal-wrapper {
  width: 665px;
  max-width: 85vw;
  max-height: 80vh;
  overflow: auto;

  .modal-close {
    justify-content: space-between !important;
    align-items: center;
    margin-bottom: 20px;

    .back-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;

      img {
        margin-right: 10px;
        margin-bottom: 2px;
      }
      span {
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        line-height: 20px;
        letter-spacing: 0.02em;
        color: $light-text-color;
      }
    }
  }
  .modal-text-wrapper {
    text-align: left;
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    letter-spacing: 0.04em;
    color: $text-color;
    margin-bottom: 15px;

    a {
      cursor: pointer;
      text-decoration: none;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 21px;
      letter-spacing: 0.04em;
      text-transform: uppercase;

      color: $main-text-color;
    }
  }
  .modal-checkbox {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    margin-bottom: 30px;

    a {
      text-decoration: none;
    }

    .modal-checkbox-text {
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 21px;
      letter-spacing: 0.04em;
      color: $main-text-color;
    }
  }
  .inputs-wrapper {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;

    .input-wrapper {
      max-width: 100%;
      margin-bottom: 20px;
      min-height: 46px;

      .info {
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        justify-content: space-between;

        .info-key {
          font-style: normal;
          font-weight: 500;
          font-size: 13px;
          line-height: 21px;
          letter-spacing: 0.04em;
          color: #606060;
          margin-right: 15px;
          white-space: break-spaces;
          width: 200px;
          text-align: left;
          margin-bottom: 10px;
        }
        .info-value {
          font-style: normal;
          font-weight: 500;
          font-size: 13px;
          line-height: 21px;
          letter-spacing: 0.04em;
          color: #606060;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-end;
          flex-grow: 1;

          span {
            margin-right: 10px;
          }
        }
      }

      .regular-input {
        width: 100%;
        color: #606060;
      }
      .regular-input::placeholder {
        color: #606060;
        opacity: 1;
      }
      .label-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        span {
          font-weight: 800;
          font-size: 12px;
          line-height: 15px;
          letter-spacing: 0.06em;
          color: rgba(160, 160, 160, 0.9);
          opacity: 0.5;
        }
        .error {
          opacity: 1;
          color: #ef3725;
          margin-left: auto;
          text-decoration: underline;
          font-size: 14px;
          margin-top: 2px;
        }
      }
    }
  }
  .input-wrapper.no-margin {
    margin-bottom: 0px;
  }
  .input-wrapper:last-child {
    margin-bottom: 0px;
    height: auto;
  }
  .btn-wrapper {
    margin-bottom: 40px;
    .btn {
      height: 48px;
    }
    .error {
      font-weight: 800;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.06em;
      color: $main-color;
      text-align: right;
    }
  }
  .recaptcha-warn {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 17px;
    color: #b3b3b3;
    text-align: left;

    a {
      text-decoration: none;
      color: #b3b3b3;
      font-weight: bold;
    }
  }
}
</style>
<style>
.modal-wrapper .dropdown {
  max-width: 100% !important;
}
</style>
